import React from "react";

export default function DotsVertical() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100"
      height="100"
      viewBox="0 0 64 64"
    >
      <path fill="#fff" d="M0 .34h64v63H0z" />
      <path
        fill="#000"
        d="M3.173 11.201h-.104a2.586 2.586 0 0 0 0 5.173h.104a2.586 2.586 0 0 0 0-5.173ZM3.173 26.718h-.104a2.586 2.586 0 0 0 0 5.173h.104a2.586 2.586 0 0 0 0-5.173ZM3.173 37.063h-.104a2.586 2.586 0 0 0 0 5.173h.104a2.586 2.586 0 0 0 0-5.173ZM5.811 60.255V50.071a2.638 2.638 0 1 0-5.276 0v10.184a2.638 2.638 0 1 0 5.276 0ZM8.448.856h-.103a2.586 2.586 0 1 0 0 5.173h.103a2.586 2.586 0 0 0 0-5.173Z"
      />
      <path
        fill="#000"
        d="M11.088 18.903v-5.031a2.638 2.638 0 0 0-5.277 0v5.03a2.638 2.638 0 0 0 5.277 0ZM8.448 42.236h-.103a2.586 2.586 0 0 0 0 5.172h.103a2.586 2.586 0 1 0 0-5.172ZM11.088 60.255v-5.03a2.638 2.638 0 1 0-5.277 0v5.03a2.638 2.638 0 1 0 5.277 0ZM13.724.856h-.104a2.586 2.586 0 0 0 0 5.173h.104a2.586 2.586 0 0 0 0-5.173Z"
      />
      <path
        fill="#000"
        d="M13.724 11.201h-.104a2.586 2.586 0 0 0 0 5.173h.104a2.586 2.586 0 0 0 0-5.173ZM13.724 31.89h-.104a2.586 2.586 0 0 0 0 5.173h.104a2.586 2.586 0 0 0 0-5.172ZM16.364 60.255v-5.03a2.638 2.638 0 0 0-5.277 0v5.03a2.638 2.638 0 1 0 5.277 0ZM19 .856h-.104a2.586 2.586 0 0 0 0 5.173H19a2.586 2.586 0 0 0 0-5.173Z"
      />
      <path
        fill="#000"
        d="M19 11.201h-.104a2.586 2.586 0 0 0 0 5.173H19a2.586 2.586 0 0 0 0-5.173ZM21.64 39.64v-5.153a2.638 2.638 0 0 0-5.276 0v5.153a2.638 2.638 0 1 0 5.276 0ZM19 47.408h-.104a2.586 2.586 0 0 0 0 5.173H19a2.586 2.586 0 0 0 0-5.173ZM19 57.753h-.104a2.586 2.586 0 0 0 0 5.172H19a2.586 2.586 0 0 0 0-5.172Z"
      />
      <path
        fill="#000"
        d="M26.917 24.056V8.718a2.638 2.638 0 1 0-5.277 0v15.338a2.638 2.638 0 1 0 5.277 0ZM26.917 39.64v-5.153a2.638 2.638 0 1 0-5.277 0v5.153a2.638 2.638 0 1 0 5.277 0ZM26.917 60.255v-5.03a2.638 2.638 0 1 0-5.277 0v5.03a2.638 2.638 0 1 0 5.277 0ZM29.552.856h-.103a2.586 2.586 0 0 0 0 5.173h.103a2.586 2.586 0 0 0 0-5.173Z"
      />
      <path
        fill="#000"
        d="M29.552 11.201h-.103a2.586 2.586 0 0 0 0 5.173h.103a2.586 2.586 0 0 0 0-5.173ZM29.552 21.546h-.103a2.586 2.586 0 0 0 0 5.172h.103a2.586 2.586 0 1 0 0-5.172ZM29.552 42.236h-.103a2.586 2.586 0 0 0 0 5.172h.103a2.586 2.586 0 1 0 0-5.172ZM34.828.856h-.104a2.586 2.586 0 1 0 0 5.173h.104a2.586 2.586 0 0 0 0-5.173ZM34.828 16.374h-.104a2.586 2.586 0 1 0 0 5.172h.104a2.586 2.586 0 0 0 0-5.172ZM34.828 31.89h-.104a2.586 2.586 0 1 0 0 5.173h.104a2.586 2.586 0 0 0 0-5.172ZM34.828 57.753h-.104a2.586 2.586 0 1 0 0 5.172h.104a2.586 2.586 0 0 0 0-5.172Z"
      />
      <path
        fill="#000"
        d="M42.746 18.903V8.718a2.638 2.638 0 0 0-5.276 0v10.185a2.638 2.638 0 0 0 5.276 0ZM42.746 44.794V34.487a2.638 2.638 0 0 0-5.276 0v10.307a2.638 2.638 0 0 0 5.276 0ZM48.023 19.025V3.442a2.638 2.638 0 0 0-5.277 0v15.583a2.638 2.638 0 1 0 5.277 0ZM48.023 39.64V29.333a2.638 2.638 0 0 0-5.277 0V39.64a2.638 2.638 0 1 0 5.277 0Z"
      />
      <path
        fill="#000"
        d="M45.38 31.89h-.104a2.586 2.586 0 0 0 0 5.173h.103a2.586 2.586 0 1 0 0-5.172ZM45.38 37.063h-.104a2.586 2.586 0 0 0 0 5.173h.103a2.586 2.586 0 1 0 0-5.173ZM50.655 6.029h-.103a2.586 2.586 0 0 0 0 5.172h.103a2.586 2.586 0 0 0 0-5.172Z"
      />
      <path
        fill="#000"
        d="M53.299 34.364V24.179a2.638 2.638 0 1 0-5.276 0v10.185a2.638 2.638 0 0 0 5.276 0ZM53.299 54.856v-4.785a2.638 2.638 0 1 0-5.276 0v4.785a2.638 2.638 0 0 0 5.276 0ZM55.931 16.374h-.103a2.586 2.586 0 1 0 0 5.172h.103a2.586 2.586 0 0 0 0-5.172Z"
      />
      <path
        fill="#000"
        d="M55.931 26.718h-.103a2.586 2.586 0 0 0 0 5.173h.103a2.586 2.586 0 0 0 0-5.173ZM58.575 49.948V39.64a2.638 2.638 0 0 0-5.276 0v10.308a2.638 2.638 0 0 0 5.276 0ZM61.114.825h-.103a2.586 2.586 0 0 0 0 5.172h.103a2.586 2.586 0 1 0 0-5.172ZM61.114 21.673h-.103a2.586 2.586 0 0 0 0 5.173h.103a2.586 2.586 0 1 0 0-5.173ZM61.114 31.855h-.103a2.586 2.586 0 1 0 0 5.172h.103a2.586 2.586 0 1 0 0-5.172Z"
      />
      <path
        fill="#000"
        d="M61.114 42.28h-.103a2.586 2.586 0 0 0 0 5.172h.103a2.586 2.586 0 1 0 0-5.173ZM61.114 52.461h-.103a2.586 2.586 0 1 0 0 5.172h.103a2.586 2.586 0 1 0 0-5.172Z"
      />
    </svg>
  );
}
